import React, { useEffect, createElement } from 'react';
export const GoogleTag = () => {
  useEffect(() => {
    // Create first script element (async script)
    const scriptAsync = document.createElement('script');
    scriptAsync.async = true;
    scriptAsync.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    document.head.appendChild(scriptAsync);
    // Create second script element (inline script)
    const scriptInline = document.createElement('script');
    scriptInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
    `;
    document.head.appendChild(scriptInline);
    // Cleanup function
    return () => {
      document.head.removeChild(scriptAsync);
      document.head.removeChild(scriptInline);
    };
  }, []); // Empty dependency array means this effect runs once on mount
  return null; // This component doesn't render anything
};